import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path, Rect} from 'react-native-svg';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';
interface IProps {
  color?: string;
  width?: number;
  height?: number;
}
export const backgroundColor = (colorValue: string) => {
  if (Settings.isAramark()) {
    return {color: Styles.Colors.PayNew.neutralHuesBase10, opacity: 1};
  }
  return {
    color: colorValue ?? Styles.Colors.PayNew.primary01,
    opacity: 0.14902,
  };
};

const PayEarnPoints = ({
  width = 51,
  height = 50,
  color = '#006DFF',
}: IProps) => (
  <Svg width={51} height={50} viewBox="0 0 51 50" fill="none">
    <Rect
      x={0.25}
      width={width}
      height={height}
      rx={8}
      fill={backgroundColor(color).color}
      fillOpacity={backgroundColor(color).opacity}
    />
    <G clipPath="url(#clip0_6409_9191)">
      <Path
        d="M23.682 13.428A4.935 4.935 0 0019.432 11h-.12a4.813 4.813 0 00-4.287 7h-1.4A2.626 2.626 0 0011 20.625v3.5c0 1.143.733 2.116 1.75 2.477V35.5c0 1.93 1.57 3.5 3.5 3.5h17.5c1.93 0 3.5-1.57 3.5-3.5v-8.898A2.632 2.632 0 0039 24.125v-3.5A2.626 2.626 0 0036.375 18h-1.4a4.813 4.813 0 00-4.288-7h-.12a4.935 4.935 0 00-4.249 2.428L25 15.676l-1.318-2.242v-.006zm12.693 7.197v3.5H26.75v-3.5h9.625zm-13.125 0v3.5h-9.625v-3.5h9.625zm0 6.125v9.625h-7a.878.878 0 01-.875-.875v-8.75h7.875zm3.5 9.625V26.75h7.875v8.75a.878.878 0 01-.875.875h-7zM30.688 18h-4.009l1.903-3.238a2.305 2.305 0 011.985-1.137h.12a2.187 2.187 0 110 4.375zm-7.438 0h-3.938a2.187 2.187 0 110-4.375h.12c.816 0 1.576.432 1.986 1.137L23.321 18h-.071z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_6409_9191">
        <Path fill="#fff" transform="translate(11 11)" d="M0 0H28V28H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default PayEarnPoints;
